// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"a47fae45","522":"f353d8a0"}[chunkId] + ".chunk.css";
};